// extracted by mini-css-extract-plugin
export default {"row":"root_common-module__row___nXxAp","col":"root_common-module__col___cUESF","link":"root_common-module__link___GDVJc"};